/**
 * Push a custom event to the GTM dataLayer (GTM-P3X9RXW).
 *
 * GTM picks the event up via a custom-event trigger and forwards it to GA4,
 * which attributes it to the session's source/campaign (e.g. the QR-code
 * UTM campaigns). Safe to call during SSR - no-ops when window is absent.
 */
export function trackEvent(event, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}
